import React, { useState } from 'react';
import { Card, Badge } from 'react-bootstrap';

const LeadCard = ({ lead, onManage, onStatusChange, statusColumns, canSelectSalesRep }) => {
    const [isChangingStatus, setIsChangingStatus] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    const handleStatusChange = async (newStatusId) => {
        if (newStatusId === lead.statusId) return;
        
        setIsChangingStatus(true);
        try {
            await onStatusChange(lead.id, newStatusId);
        } finally {
            setIsChangingStatus(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const isPending = lead.hasPendingLeads;
    const currentStatus = statusColumns.find(s => s.id === lead.statusId);

    const handleDragStart = (e) => {
        setIsDragging(true);
        e.dataTransfer.setData('text/plain', JSON.stringify({ leadId: lead.id, currentStatus: lead.statusId }));
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragEnd = () => {
        setIsDragging(false);
    };

    const handleCardClick = (e) => {
        // Solo navegar si no se está arrastrando
        if (!isDragging) {
            onManage(lead);
        }
    };

    return (
        <Card 
            className={`lead-card mb-2 ${isPending ? 'border-danger' : ''} ${lead.isUrgent ? 'urgent-lead' : ''} ${isDragging ? 'dragging' : ''}`}
            draggable
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onClick={handleCardClick}
            style={{ cursor: isDragging ? 'grabbing' : 'pointer' }}
        >
            <Card.Body className="p-3">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6 className="card-title mb-1">
                        {lead.name}
                        {isPending && (
                            <i className="bi bi-exclamation-triangle-fill text-danger ms-1" title="Lead pendiente"></i>
                        )}
                        {lead.isUrgent && (
                            <i className="bi bi-lightning-fill urgent-icon ms-1" title="Lead urgente" style={{ color: '#ff6b35', fontSize: '1.2em', animation: 'urgentIcon 2s infinite' }}></i>
                        )}
                    </h6>
                    <small className="text-muted">#{lead.id}</small>
                </div>

                <div className="lead-info">
                    <div className="mb-1">
                        <i className="bi bi-telephone me-1"></i>
                        <small>{lead.phone || 'Sin teléfono'}</small>
                    </div>
                    
                    <div className="mb-1">
                        <i className="bi bi-geo-alt me-1"></i>
                        <small>{lead.zipCode || 'Sin código postal'}</small>
                    </div>



                    {canSelectSalesRep && lead.salesRep && (
                        <div className="mb-1">
                            <i className="bi bi-person me-1"></i>
                            <small>
                                <span 
                                    className="badge" 
                                    style={{ 
                                        backgroundColor: lead.salesRep.colourHex || '#6c757d', 
                                        color: 'white',
                                        fontSize: '0.75rem'
                                    }}
                                >
                                    {lead.salesRep.name} {lead.salesRep.lastName1}
                                </span>
                            </small>
                        </div>
                    )}

                    {lead.subStatus?.name && (
                        <div className="mb-2">
                            <small className="text-muted d-block mb-1">Detalle:</small>
                            <Badge bg="secondary" className="small">
                                {lead.subStatus.name}
                            </Badge>
                        </div>
                    )}

                    <div className="mb-1">
                        <i className="bi bi-calendar-plus me-1"></i>
                        <small className="text-muted">Creado: {formatDateTime(lead.createdTime)}</small>
                    </div>



                    {lead.comments && (
                        <div className="mb-1">
                            <small className="text-muted d-block" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>
                                <strong>Comentario:</strong> {lead.comments.length > 80 ? `${lead.comments.substring(0, 80)}...` : lead.comments}
                            </small>
                        </div>
                    )}
                </div>


            </Card.Body>
        </Card>
    );
};

export default LeadCard;